<div class="costInput" [class.costInput--focused]="focused" (click)="focusInput()" #inputContainer>
  @if (ppLeftUnit && ppUnit) {
    <span class="costInput__icon-container">
      <span class="costInput__unit" ppTooltip [ppTrimTooltip]="true" [ppTitle]="ppUnit">
        {{ ppUnit }}
      </span>
    </span>
  }

  <input
    #input
    [ppAutonumeric]="autonumericOptions"
    class="costInput__input"
    aria-label="number value"
    [placeholder]="ppPlaceholder"
    [(ngModel)]="ppValue"
    (keydown.enter)="blurInput($event)"
    (blur)="onInputFocused(false)"
    (focus)="onInputFocused(true)"
    (ppFormatted)="updateField($event)"
    />

  @if (!ppLeftUnit && ppUnit) {
    <div
      class="costInput__icon-container costInput__icon-container--border-right"
      >
      <span class="costInput__unit" ppTooltip [ppTrimTooltip]="true" [ppTitle]="ppUnit">
        {{ ppUnit }}
      </span>
    </div>
  }
</div>
